import { FormControl, TextField, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import { stringifyJSONAttributes, stringToBooleanConversion, decryptString, encryptString } from '../../../utils/utilFunctions';
import _ from 'lodash';

const AmazonSQS = ({ connectionDetails, handleBodyContent, direction, screen, disableControl, repoPDC, useConnection }) => {
  const { t } = useTranslation();
  const [outTime, setOutTime] = useState('');
  const [url, setUrl] = useState('');
  const [accessKey, setAccessKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [deduplication, setDeduplication] = useState('');
  const [group, setGroup] = useState('');
  const [content, setContent] = useState(null);
  const [workflowSessionModal, setWorkflowSessionModal] = useState({open: false, isFirstTime: false});
  const [valueLabel, setValueLabel] = useState("");

  const removeUndefinedAndNullKeys = (obj = {}) => {
    const tempObj = {...obj}
    Object.keys(tempObj || {}).forEach(e => {
        if(tempObj[e] === undefined || tempObj[e] === null) delete tempObj[e];
    })
    return tempObj
  }

  const debouncedContentUpdate = debounce(handleBodyContent, 500);

  const onInputChange = (name, value) => {
    if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
      setContent((prev) => {
        return {[name]: value };
      });
    } else {
      setContent((prev) => {
        return { ...prev, [name]: value };
      });
    }
  };

  useEffect(() => {
    if(!_.isEqual(removeUndefinedAndNullKeys(content), removeUndefinedAndNullKeys(connectionDetails))) {
      debouncedContentUpdate(content);
    }
  }, [content]);

  useEffect(() => {
    setOutTime(connectionDetails?.TIMEOUT || '');
    setUrl(connectionDetails?.URL || '');
    setAccessKey(connectionDetails?.ACCESS_KEY_ID || '');
    setSecretKey(connectionDetails?.SECRET_KEY_ID || '');
    setDeduplication(connectionDetails?.DURABLE_SUBSCRIPTION_CLIENT_ID || '');
    setGroup(connectionDetails?.MESSAGE_GROUP_ID || '');
    setContent({ ...connectionDetails })
  }, [connectionDetails]);

  const getFontWeight = (control, currentValue, useConnection) => {
    if (!repoPDC) return "normal";
    return repoPDC?.[control] !== currentValue &&
      useConnection === "preDefined"
      ? "bold"
      : "normal";
  };

  const fontWeights = {
    timeout: getFontWeight("TIMEOUT", outTime, useConnection),
    url: getFontWeight("URL", url, useConnection),
    accessKey: getFontWeight("ACCESS_KEY_ID", accessKey, useConnection),
    secretKey: getFontWeight("SECRET_KEY_ID", secretKey, useConnection),
    deduplication: getFontWeight("DURABLE_SUBSCRIPTION_CLIENT_ID", deduplication, useConnection),
    group: getFontWeight("MESSAGE_GROUP_ID", group, useConnection)
  };

  return (
    <>
      <div style={{display:'flex', gap:'4px'}}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            disabled={disableControl || false}
            label={t("LBL_TIMEOUT")}
            type="text"
            value={outTime}
            onChange={(e) => {
              const inputValue = e.target.value;
              const numericValue = inputValue.replace(/\D/g, '');
              if(['GET_DATA', 'SEND_DATA'].includes(screen)) {
                setOutTime(inputValue);
                onInputChange(e.target.name, inputValue);
              }else{
                if (numericValue.length <= 9) {
                  setOutTime(numericValue);
                  onInputChange(e.target.name, numericValue);
                }
              }
            }}
            className={"width-100"}
            name={"TIMEOUT"}
            autoComplete="off"
            inputProps={{
              style: { fontWeight: fontWeights.timeout }
            }}
          />
        </FormControl>
        {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_TIMEOUT"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{display:'flex', gap:'4px'}}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            disabled={disableControl || false}
            label={t("LBL_URL")}
            type="text"
            value={url}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setUrl(e.target.value)
            }}
            className={"width-100"}
            name={"URL"}
            autoComplete="off"
            inputProps={{
              style: { fontWeight: fontWeights.url }
            }}
          />
        </FormControl>
        {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_URL"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{display:'flex', gap:'4px'}}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            disabled={disableControl || false}
            label={t("LBL_ACCESS_KEY_ID")}
            type="text"
            value={accessKey}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setAccessKey(e.target.value)
            }}
            className={"width-100"}
            name={"ACCESS_KEY_ID"}
            autoComplete="off"
            inputProps={{
              style: { fontWeight: fontWeights.accessKey }
            }}
          />
        </FormControl>
        {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_ACCESS_KEY_ID"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      <div style={{display:'flex', gap:'4px'}}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            disabled={disableControl || false}
            label={t("LBL_SECRET_KEY_ID")}
            type="text"
            value={secretKey}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setSecretKey(e.target.value)
            }}
            className={"width-100"}
            name={"SECRET_KEY_ID"}
            autoComplete="off"
            inputProps={{
              style: { fontWeight: fontWeights.secretKey }
            }}
          />
        </FormControl>
        {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
          <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
              setValueLabel(t("LBL_SECRET_KEY_ID"));
              setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
          </Button>
        )}
      </div>
      {
        direction === 'OUT' && <>
          <div style={{display:'flex', gap:'4px'}}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                disabled={disableControl || false}
                label={t("LBL_MESSAGE_DEDUPLICATION_ID")}
                type="text"
                value={deduplication}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setDeduplication(e.target.value)
                }}
                className={"width-100"}
                name={"DURABLE_SUBSCRIPTION_CLIENT_ID"}
                autoComplete="off"
                inputProps={{
                  style: { fontWeight: fontWeights.deduplication }
                }}
              />
            </FormControl>
            {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_MESSAGE_DEDUPLICATION_ID"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{display:'flex', gap:'4px'}}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                disabled={disableControl || false}
                label={t("LBL_MESSAGE_GROUP_ID")}
                type="text"
                value={group}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setGroup(e.target.value)
                }}
                className={"width-100"}
                name={"MESSAGE_GROUP_ID"}
                autoComplete="off"
                inputProps={{
                  style: { fontWeight: fontWeights.group }
                }}
              />
            </FormControl>
            {(screen === 'GET_DATA' || screen === 'SEND_DATA') && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_MESSAGE_GROUP_ID"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
        </>
      }
      <WorkflowSessionModal
        valueLabel={valueLabel}
        showAccountData={true}
        showCallingWorkflow={true}
        showSystemData={true}
        showWorkflowSession={true}
        showDateAndTime={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={
          valueLabel === t("LBL_TIMEOUT")
            ? outTime
            : valueLabel === t("LBL_URL")
            ? url
            : valueLabel === t("LBL_ACCESS_KEY_ID")
            ? accessKey
            : valueLabel === t("LBL_SECRET_KEY_ID")
            ? secretKey
            : valueLabel === t("LBL_MESSAGE_DEDUPLICATION_ID")
            ? deduplication
            : valueLabel === t("LBL_MESSAGE_GROUP_ID")
            ? group
            : ""
        }
        valuesHandler={(value) => {
          if (valueLabel === t("LBL_TIMEOUT")) {
              onInputChange("TIMEOUT", value);
              setOutTime(value);
          } else if (valueLabel === t("LBL_URL")) {
            onInputChange("URL", value);
            setUrl(value);
          } else if (valueLabel === t("LBL_ACCESS_KEY_ID")) {
            onInputChange("ACCESS_KEY_ID", value);
            setAccessKey(value);
          } else if (valueLabel === t("LBL_SECRET_KEY_ID")) {
            onInputChange("SECRET_KEY_ID", value);
            setSecretKey(value);
          } else if (valueLabel === t("LBL_MESSAGE_DEDUPLICATION_ID")) {
            onInputChange("DURABLE_SUBSCRIPTION_CLIENT_ID", value);
            setDeduplication(value);
          } else if (valueLabel === t("LBL_MESSAGE_GROUP_ID")) {
            onInputChange("MESSAGE_GROUP_ID", value);
            setGroup(value);
          }
        }}
      />
    </>
  )
}

export default AmazonSQS